export default "__VITE_ASSET__BEfTe1qZ__"